type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

type AvatarProps = {
  src: string | null | undefined;
  name?: string;
  size?: AvatarSize;
  className?: string;
};

const sizeMap: Record<AvatarSize, string> = {
  xs: 'w-5 h-5',
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  name,
  size = 'sm',
  className,
}) => {
  const wrapperClass = [
    sizeMap[size],
    'rounded-full overflow-hidden bg-surface-200 flex items-center justify-center shrink-0',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClass}>
      {src ? (
        <img
          src={src}
          alt={name ?? ''}
          className="w-full h-full object-cover"
        />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-1/2 h-1/2 text-muted-foreground"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
            clipRule="evenodd"
          />
        </svg>
      )}
    </div>
  );
};
